import React, { Fragment } from "react";
import { Link, withRouter } from "react-router-dom";
import ax from "./auth/axios";
import { API_ROOT } from "./utils/api-config";
import { connect } from "react-redux";
import { editDriverProfile } from "../actions/driverAction";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import ButtonGroup from "react-bootstrap/ButtonGroup";
import Navbar from "react-bootstrap/Navbar";

class EditDriverProfile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      first_name: "",
      last_name: "",
      active: "",
      icloud_email: "",
      mobile_contact_number: "",
      iPhone: false,
      twilio_phone_number: "",
      active_conversation_phone_number: "",
      active_delivery_id: "",
    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    const { driver } = this.props;
    this.setState({
      first_name: driver.first_name || "",
      last_name: driver.last_name || "",
      active: driver.active || false,
      icloud_email: driver.icloud_email || "",
      iPhone: driver.iPhone || false,
      mobile_contact_number: driver.mobile_contact_number || "",
      mobile_phone_type: driver.mobile_phone_type || "",
      twilio_phone_number: driver.twilio_phone_number || "",
      active_conversation_phone_number:
        driver.active_conversation_phone_number || "",
      active_delivery_id: driver.active_delivery_id || "",
    });
  }
  handleSubmit(e) {
    e.preventDefault();
    const formData = new FormData();
    let token = "Bearer " + localStorage.getItem("token");
    const config = {
      headers: {
        Authorization: token,
        "Content-Type": "application/x-www-form-urlencoded",
      },
    };
    formData.append("driver[first_name]", this.state.first_name);
    formData.append("driver[last_name]", this.state.last_name);
    formData.append("driver[icloud_email]", this.state.icloud_email);
    formData.append("driver[active]", this.state.active);
    formData.append(
      "driver[mobile_contact_number]",
      this.state.mobile_contact_number
    );
    formData.append("driver[iPhone]", this.state.iPhone);
    formData.append("driver[mobile_phone_type]", this.state.mobile_phone_type);
    formData.append(
      "driver[twilio_phone_number]",
      this.state.twilio_phone_number
    );
    formData.append(
      "driver[active_conversation_phone_number]",
      this.state.active_conversation_phone_number
    );
    formData.append(
      "driver[active_delivery_id]",
      this.state.active_delivery_id
    );
    ax.patch(
      `${API_ROOT}/drivers/${this.props.match.params.id}`,
      formData,
      config
    ).then((response) => {
      this.props.editDriverProfile(response.data);
    });
  }
  handleInputChange(event) {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
  }
  render() {
    return (
      <div className="container-fluid">
        <Navbar className="bg-info justify-content-between">
          <Navbar.Brand>
            Edit Driver Profile of {this.state.first_name}{" "}
            {this.state.last_name}
          </Navbar.Brand>
        </Navbar>
        <Form onSubmit={this.handleSubmit}>
          <br></br>
          <Form.Row>
            <Form.Group as={Col} controlId="formGridFirstName">
              <Form.Label>First Name</Form.Label>
              <Form.Control
                onChange={this.handleInputChange}
                name="first_name"
                value={this.state.first_name}
              />
            </Form.Group>
            <Form.Group as={Col} controlId="formGridLastName">
              <Form.Label>Last Name</Form.Label>
              <Form.Control
                name="last_name"
                onChange={this.handleInputChange}
                value={this.state.last_name}
              />
            </Form.Group>
            <Col sm="2">
              <Form.Group>
                <Form.Label>Active</Form.Label>
                <Form.Check
                  name="active"
                  checked={this.state.active}
                  onChange={this.handleInputChange}
                />
              </Form.Group>
            </Col>
          </Form.Row>
          <Form.Row>
            <Form.Group as={Col} controlId="formGridMobile">
              <Form.Label>Mobile Phone</Form.Label>
              <Form.Control
                onChange={this.handleInputChange}
                value={
                  this.state.mobile_contact_number
                    ? this.state.mobile_contact_number
                    : ""
                }
                name="mobile_contact_number"
              />
            </Form.Group>
            {/* <Form.Group as={Col} controlId="formGridType">
              <Form.Label>Mobile Phone Type</Form.Label>
              <Form.Control
              onChange={this.handleInputChange}
              value={
                this.state.mobile_phone_type
                ? this.state.mobile_phone_type
                : ""
              }
              name="mobile_phone_type"
              />
            </Form.Group> */}
            <Col sm="2">
              <Form.Group>
                <Form.Label>Apple iPhone</Form.Label>
                <Form.Check
                  name="iPhone"
                  checked={this.state.iPhone}
                  onChange={this.handleInputChange}
                />
              </Form.Group>
            </Col>
            <Form.Group as={Col} controlId="formGridEmail">
              <Form.Label>iCloud Email</Form.Label>
              <Form.Control
                name="icloud_email"
                onChange={this.handleInputChange}
                value={this.state.icloud_email ? this.state.icloud_email : ""}
              />
            </Form.Group>
          </Form.Row>
          <Form.Row>
            <Form.Group as={Col} controlId="formGridTwilio">
              <Form.Label>Twilio Phone</Form.Label>
              <Form.Control
                name="twilio_phone_number"
                onChange={this.handleInputChange}
                value={
                  this.state.twilio_phone_number
                    ? this.state.twilio_phone_number
                    : ""
                }
              />
            </Form.Group>
            <Form.Group as={Col} controlId="formGridCustomerPhone">
              <Form.Label>Active Conversation Phone</Form.Label>
              <Form.Control
                onChange={this.handleInputChange}
                value={
                  this.state.active_conversation_phone_number
                    ? this.state.active_conversation_phone_number
                    : ""
                }
                name="active_conversation_phone_number"
              />
            </Form.Group>
            <Form.Group as={Col} controlId="formGridDelivery">
              <Form.Label>Active Delivery Id</Form.Label>
              <Form.Control
                onChange={this.handleInputChange}
                value={
                  this.state.active_delivery_id
                    ? this.state.active_delivery_id
                    : ""
                }
                name="active_delivery_id"
              />
            </Form.Group>
          </Form.Row>
          <Button type="submit" variant="outline-danger">
            Save Changes
          </Button>
        </Form>
      </div>
    );
  }
}
const mapDispatchToProps = (dispatch) => ({
  editDriverProfile: (driver) => dispatch(editDriverProfile(driver)),
});
export default withRouter(connect(null, mapDispatchToProps)(EditDriverProfile));
